import { isUnknownObject } from '~/shared/utils/guards'
import { BaseModel, fillOwnProperties } from '~/shared/model'

export default class EmployerInfoModel extends BaseModel {
  static override constructorName = 'EmployerInfoModel'

  public id: string = ''
  public slug: string = ''
  public name: string = ''

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)
    }
  }
}
